<h4>Also in this delivery</h4>

@for (item of details().packages; track $index) {
  <div
    class="d-flex p--16 align-items-center"
    [class.sidebar-quickselect--active]="item.id === details().id"
    (click)="onSelectionChanged(item)"
    (keyup)="onKeyUp($event, item)"
    tabindex="0"
    role="button"
  >
    <div class="sidebar-quickselect__arrow">
      <i class="pi pi-angle-left"></i>
    </div>
    <div class="sidebar-quickselect__content-wrapper">
      <div class="sidebar-quickselect__label">{{ item.trackingNumber }}</div>
      <div>{{ item.progressDetailsDescription }}</div>
    </div>
    <div>
      <myarvato-traffic-light-bubble [dataRule]="bubbleRules" [value]="item.progress" [showLabel]="false" />
    </div>
  </div>
}
